import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import globalSearchClient from "../../../apis/globalSearchClient";
import GlobalUtils from "../../../utils/GlobalUtils";
import SearchItem from "./SearchItem";
import { useDebouncedEffect } from "../../../hooks/useDebouncedEffect";
import AwesomeIcon from "@icons/AwesomeIcon";
import IcomoonIcon from "@icons/IcomoonIcon";
import SntTargetIcon from "@icons/SntTargetIcon";
import SntSearchIcon from "@icons/SntSearchIcon";
import SntInOrientationIcon from "@icons/SntInOrientationIcon";
import SntPartnersIcon from "@icons/SntPartnersIcon";
import { DeviceHomeRoute } from "@/cleanup/utils/routesUtil/routesUtil";
import GeozoneImageDefault from "@images/default/geozone_default.svg";

function SearchPanel({ searchText, closePopup }) {
  const [query, setQuery] = useState(null);
  const [isRecent, setIsRecent] = useState(false);
  const [isNotFound, setIsNotFound] = useState(false);
  const [searchData, setSearchData] = useState();
  const language = useSelector((state) => state.language);
  const loginInfo = useSelector((state) => state.user);
  let { permissionsMap, features } = loginInfo;

  useEffect(() => {
    setQuery(searchText);
  }, [searchText]);

  useDebouncedEffect(() => loadData(query), 500, [query]);

  const loadData = (search) => {
    // eslint-disable-next-line no-extra-boolean-cast
    if (!!search) {
      setSearchData([]);
      setIsRecent(false);
      globalSearchClient.search(search).then(({ data }) => {
        drawDataSearch(data, search);
      });
    } else if (!search) {
      setSearchData([]);
      setIsRecent(true);
      setIsNotFound(false);
      globalSearchClient.getSearchHistory().then(({ data }) => {
        drawRecentViewed(data);
      });
    }
  };

  const drawDataSearch = (data) => {
    let map = {};

    if (data.length === 0) {
      setIsNotFound(true);
      return;
    }
    setIsNotFound(false);
    for (let index = 0; index < data.length; index++) {
      const item = data[index];
      if (map[item.category]) {
        let arr = map[item.category];
        arr.push(item);
        map[item.category] = arr;
      } else {
        let arr1 = [];
        arr1.push(item);
        map[item.category] = arr1;
      }
    }
    const items = Object.entries(map);
    let listData = [];
    for (let index = 0; index < items.length; index++) {
      const element = items[index];
      let categorySearch = { name: element[0], dataSearch: element[1] };
      listData.push(categorySearch);
    }

    let searchList = [];
    for (let index = 0; index < listData.length; index++) {
      const element = listData[index];
      searchList.push(element);
    }
    let datasHandle = [];
    for (let i = 0; i < searchList.length; i++) {
      const value = searchList[i];
      let searchItem;
      let searchItems = [];
      for (let index = 0; index < value?.dataSearch.length; index++) {
        const element = value?.dataSearch[index];
        let obj = getData(element);
        searchItems.push(obj);
      }
      searchItem = { name: value.name, listItem: searchItems };
      datasHandle.push(searchItem);
    }
    setSearchData(datasHandle);
  };
  const drawRecentViewed = (data) => {
    let searchList = [];
    for (let index = 0; index < data.length; index++) {
      const item = data[index];
      let obj = getData(item.searchIndex);
      searchList.push(obj);
    }
    let searchDatas = [];
    searchDatas.push({
      name: language.v41_recent_viewed_key,
      listItem: searchList,
    });
    setSearchData(searchDatas);
  };

  const getData = (data) => {
    let link = "",
      icon_class = "",
      category = "",
      element = null,
      entityType = "",
      resourceType = "image";

    let _suffix = "?";

    switch (data.category) {
      case "Asset":
        link = DeviceHomeRoute.getUpdatePage({
          id: data.entityId,
        });

        icon_class = (
          <img
            src="/images/device/tracker_default.svg"
            alt=""
            style={{ width: 30, height: 30 }}
          />
        );
        category = language.assets_key;
        entityType = "device";
        break;

      case "AlertRule":
        link =
          "/manage_alerts_update" +
          _suffix +
          "type=view&id=" +
          data.entityId +
          "&org=" +
          data.orgId;
        icon_class = <IcomoonIcon icon="warning" size="30"></IcomoonIcon>;
        category = language.sidebar_admin_alerts_key;
        break;

      case "Geozone":
        link =
          "/geozone_individual" +
          _suffix +
          "type=view&id=" +
          data.entityId +
          "&org=" +
          data.orgId;
        icon_class = (
          <img
            src={GeozoneImageDefault}
            alt=""
            style={{ width: 30, height: 30 }}
          />
        );
        category = language.geozones_key;
        entityType = "geozone";
        break;

      case "Infrastructure":
        link =
          "/infrastructures_update" +
          _suffix +
          "type=view&id=" +
          data.entityId +
          "&org=" +
          data.orgId;
        icon_class = <SntTargetIcon size={30}></SntTargetIcon>;
        category = language.infrastructure_key;
        break;

      case "User":
        link =
          "/users_admin_update" +
          _suffix +
          "type=view&id=" +
          data.entityId +
          "&org=" +
          data.orgId;
        icon_class = <IcomoonIcon icon="users" size="30"></IcomoonIcon>;
        category = language.sidebar_admin_users_key;
        entityType = "user";
        resourceType = "avatar";
        break;

      case "Organization":
        if (permissionsMap["ORGANIZATION_MANAGE"]) {
          link =
            "/organization_update" + _suffix + "type=edit&org=" + data.entityId;
        } else {
          link =
            "/organization_update" + _suffix + "type=view&org=" + data.entityId;
        }
        icon_class = <AwesomeIcon icon="user-group" size="2xl"></AwesomeIcon>;
        category = language.organization_key;
        break;

      case "Partner":
        link = "/partners_update" + _suffix + "type=view&id=" + data.entityId;
        icon_class = <SntPartnersIcon size={30} />;
        category = language.partner_partners_key;
        break;
      case "Sensor":
        link =
          "/ble_sensor_update" +
          _suffix +
          "type=view&id=" +
          data.entityId +
          "&org=" +
          data.orgId;
        icon_class = <SntInOrientationIcon size={30} />;
        category = language.sidebar_ex_ble_sensor_title_key;
        break;
      default:
        break;
    }

    let img = "";
    if (data.iconPath) {
      img = (
        <img
          style={{ float: "left", width: 30, height: 30, marginRight: 10 }}
          src={GlobalUtils.getFile(
            entityType,
            data.entityId,
            resourceType,
            data.iconPath,
            "small"
          )}
          alt=""
        />
      );
    } else {
      img = (
        <span style={{ float: "left", marginRight: 10, paddingTop: 5 }}>
          {icon_class}
        </span>
      );
    }

    return {
      link: link,
      img: img,
      category: category,
      element: element,
      data: data,
    };
  };

  return (
    <div id="search-panel">
      <div className="d-md-none">
        <div className="gb-search-input">
          <input
            id="search-input"
            type="search"
            className="form-control"
            placeholder="Search…"
            autoComplete="off"
            onChange={(e) => {
              setQuery(e.target.value);
            }}
            style={{ position: "relative" }}
          />
          <SntSearchIcon />
        </div>
      </div>
      <ul className="gb-search-item snt-scrollbar">
        {!isNotFound &&
          searchData
            ?.filter(
              (item) =>
                item.name !== "Geozone" ||
                (features.geozone_db &&
                  permissionsMap["MENU_HOME_GEOZONE_OVERVIEW"])
            )
            .map((item, index) => (
              <SearchItem
                key={index}
                dataSearch={item}
                language={language}
                closePopup={() => closePopup()}
                isRecent={isRecent}
                strSearch={searchText}
              />
            ))}
        <div
          className="not-found text-center"
          style={{
            paddingTop: 30,
            display: `${isNotFound ? "block" : "none"}`,
            color: "#424B59",
          }}
        >
          <SntSearchIcon size={60} />
          <div style={{ fontSize: 16, fontWeight: "bold" }}>
            {language.v41_no_matching_search_results_key}
          </div>
          <div className="fs-6">
            {" "}
            {language.v41_try_again_using_more_general_search_terms_key}{" "}
          </div>
        </div>
      </ul>
    </div>
  );
}

SearchPanel.propTypes = {};

export default SearchPanel;
